export const DHL = "dhl";
export const FEDEX = "fedex";
export const UPS = "ups";
export const OTHER = "other";
export const TBD = "tbd";

export const NOTE = "note";
export const INTERNAL_NOTE = "internal_note";
export const NOTE_TYPE = "note_type";

export const DEFAULT_CARRIERS = [FEDEX, UPS, DHL];

export const CARRIERS = {
  [DHL]: {
    label: "DHL",
    shippingMethods: {
      dhl_express: { label: "DHL Express" },
      envelope: { label: "Envelope", deprecated: true },
      express_worldwide: { label: "Express Worldwide" },
      standard: { label: "Standard", deprecated: true },
      dhl_domestic_express: {
        label: "DHL Domestic Express-by 6pm (within Ireland only)"
      }
    }
  },
  [FEDEX]: {
    label: "FedEx",
    shippingMethods: {
      "1_day_freight": { label: "1-Day Freight" },
      "1_day_freight_over_150_lbs": {
        label: "1-Day Freight (over 150 lbs.)",
        deprecated: true
      },
      "1_day_priority_overnight": {
        label: "1 Day Priority Overnight (By 10AM)",
        deprecated: true
      },
      "1_day_standard_overnight": {
        label: "1 Day Standard Overnight (By 5PM)",
        deprecated: true
      },
      "2_day": { label: "2-Day" },
      "2_day_air_am": { label: "2-Day AM" },
      "2_day_economy": { label: "2 Day Economy", deprecated: true },
      "2_day_freight": { label: "2-Day Freight" },
      "2_day_freight_over_150_lbs": {
        label: "2-Day Freight (over 150 lbs.)",
        deprecated: true
      },
      "3_day_express_saver": { label: "3-Day Express Saver" },
      "3_day_freight": { label: "3-Day Freight" },
      "3_day_freight_over_150_lbs": {
        label: "3-Day Freight (over 150 lbs.)",
        deprecated: true
      },
      express_envelope: { label: "Express (Envelope)", deprecated: true },
      first_overnight: { label: "First Overnight" },
      first_overnight_freight: { label: "First Overnight Freight" },
      freight_economy_ltl: { label: "Freight® Economy LTL" },
      freight_priority_ltl: { label: "Freight® Priority LTL" },
      ground: { label: "Ground" },
      international_ground: { label: "International Ground" },
      international_economy_freight: {
        label: "International Economy Freight"
      },
      international_first: { label: "International First" },
      international_freight: { label: "International Priority Freight" },
      intl_economy: {
        label: "International Economy"
      },
      intl_priority: {
        label: "International Priority"
      },
      intl_standard: {
        label: "Intl Standard [only valid when shipping outside of U.S.]",
        deprecated: true
      },
      priority_overnight: { label: "Priority Overnight" },
      saturday_delivery: { label: "Saturday Delivery" },
      standard_overnight: { label: "Standard Overnight" }
    }
  },
  [UPS]: {
    label: "UPS",
    shippingMethods: {
      "2nd_day_air_am": { label: "2nd Day Air AM" },
      "2nd_day_air": { label: "2nd Day Air" },
      "2nd_day_air_freight_g": { label: "2nd Day Air Freight Guaranteed" },
      "2nd_day_air_freight_ngs": {
        label: "2nd Day Air Freight Non-Guaranteed"
      },
      "2nd_day_air_standard": {
        label: "2nd Day Air Standard (by end-of-day)",
        deprecated: true
      },
      "3rd_day_air_freight_g": { label: "3rd Day Air Freight Guaranteed" },
      "3rd_day_air_freight_ngs": {
        label: "3rd Day Air Freight Non-Guaranteed"
      },
      "3rd_day_select": { label: "3 Day Select" },
      air_freight_premium_direct: { label: "Air Freight Premium Direct" },
      air_freight_direct: { label: "Air Freight Direct" },
      air_freight_consolidated: { label: "Air Freight Consolidated" },
      express_saver: {
        label: "Express Saver"
      },
      freight_LTL: { label: "Freight LTL" },
      freight_LTL_g: { label: "Freight LTL Guaranteed" },
      freight_LTL_g_am: { label: "Freight LTL Guaranteed AM" },
      ground: { label: "Ground" },
      intl_express_freight_ltl_g: {
        label: "Intl Express Freight LTL Guaranteed",
        deprecated: true
      },
      intl_express_freight_ltl_ngs: {
        label: "Intl Express Freight  LTL Non-Guaranteed",
        deprecated: true
      },
      next_day_air_early_am: { label: "Next Day Air Early" },
      next_day_air: { label: "Next Day Air" },
      next_day_air_freight_g: { label: "Next Day Air Freight Guaranteed" },
      next_day_air_freight_ngs: {
        label: "Next Day Air Freight Non-Guaranteed"
      },
      next_day_air_saver: {
        label: "Next Day Air Saver"
      },
      next_day_air_standard: {
        label: "Next Day Air Standard (by Noon)",
        deprecated: true
      },
      saturday_delivery: {
        label: "Saturday Delivery"
      },
      standard: {
        label: "Standard"
      },
      standard_ground_to_ca: {
        label: "Standard Ground to Canada (by end-of-day)",
        deprecated: true
      },
      worldwide_expedited: {
        label: "Worldwide Expedited"
      },
      worldwide_express: {
        label: "Worldwide Express"
      },
      worldwide_express_plus: {
        label: "Worldwide Express Plus"
      },
      worldwide_express_std: {
        label: "Worldwide Express Std",
        deprecated: true
      },
      worldwide_saver: {
        label: "Worldwide Saver",
        deprecated: true
      },
      worldwide_express_freight_midday: {
        label: "Worldwide Express Freight Midday"
      },
      worldwide_express_freight: {
        label: "Worldwide Express Freight"
      },
      worldwide_saver_express: {
        label: "Worldwide Saver (Express)"
      }
    }
  },
  [TBD]: {
    label: "TBD",
    shippingMethods: {
      dim_weight: {
        label: "TBD"
      }
    }
  },
  [OTHER]: {
    label: "Other",
    shippingMethods: {
      courier_pick_up_lazer_ship: { label: "Courier Pick-Up - Lazer Ship" },
      courier_pick_up_sterling: { label: "Courier Pick-Up - Sterling" },
      courier_pick_up_unknown: { label: "Courier Pick-Up - Unknown" },
      hand_delivery: { label: "Hand Delivery" },
      no_charge: { label: "No Freight Charge - Customer to Pay" },
      other: { label: "Other" },
      release_ownership_at_shop: { label: "Release Ownership At Shop" },
      will_call: { label: "Will Call - Customer Pick-Up" }
    }
  }
};



// WEBPACK FOOTER //
// ./app/modules/shared/constants.js